module.exports = "https://cdn.littlereply.com/tt/resource/earn_guide_step_2@3x.407f3173c5c8b52e491dcc1dd5caaf90.png";